import { activityNames, activityTypes } from '../../../utils/constants/misc'
import {
  dateOperators,
  equalityOperators,
  multiselectOperators,
  textOperators
} from '../../../utils/constants/operators'

export const productColumns = [
  {
    name: 'reference',
    label: 'Référence',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'name',
    label: 'Nom',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'createdDateTime',
    label: 'Date Création',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'createdBy',
    label: 'Créé Par',
    isFilter: true,
    operators: textOperators
  },
  {
    name: 'lastModDateTime',
    label: 'Date Modification',
    isFilter: true,
    inputType: 'datetime-local',
    type: 'date',
    format: 'DD/MM/YYYY HH:mm:ss',
    operators: dateOperators
  },
  {
    name: 'lastModBy',
    label: 'Modifié Par',
    isFilter: true,
    operators: textOperators
  }
]

export const getProductFields = (attach, setProductOptions) => [
  [
    {
      name: 'reference',
      label: 'Référence',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Référence obligatoire'
        }
      ]
    },
    {
      name: 'isOnline',
      label: 'En ligne',
      fullWidth: true,
      type: 'checkbox'
    }
  ],
  [
    {
      name: 'name',
      label: 'Nom',
      required: true,
      type: 'text',
      fullWidth: true,
      validation: [
        {
          rule: 'req',
          error: 'Nom obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'shortDescription',
      label: 'Description Courte',
      required: true,
      type: 'joditEditor',
      fullWidth: true
    },
    {
      name: 'description',
      label: 'Description',
      required: true,
      type: 'joditEditor',
      fullWidth: true
    }
  ],
  [
    {
      name: 'technicalDetails',
      label: 'Détails Techniques',
      required: true,
      type: 'joditEditor',
      fullWidth: true
    }
  ],
  [
    {
      name: 'cost',
      label: 'Coût',
      required: true,
      fullWidth: true,
      type: 'currency',
      min: 0,
      validation: [
        {
          rule: 'req',
          error: 'Coût obligatoire'
        }
      ]
    },
    {
      name: 'margin',
      label: 'Taux marge',
      required: true,
      fullWidth: true,
      type: 'float',
      min: 0,
      validation: [
        {
          rule: 'req',
          error: 'Taux marge obligatoire'
        }
      ]
    }
  ],
  [
    {
      name: 'stock',
      label: 'Stock',
      required: true,
      fullWidth: true,
      type: 'number',
      min: 0,
      validation: [
        {
          rule: 'req',
          error: 'Stock obligatoire'
        }
      ]
    },
    {
      name: 'isBuildable',
      label: 'Reproduction',
      fullWidth: true,
      type: 'checkbox'
    },
    {
      name: 'isCustomizable',
      label: 'Personnalisable',
      fullWidth: true,
      type: 'checkbox'
    }
  ],
  [
    {
      tab: '1',
      name: 'logo',
      label: 'Images',
      type: 'image-multi',
      files: (data) => data.attachments?.filter((a) => a.type === 'image')
    }
  ],
  [
    {
      tab: '1',
      name: 'file',
      label: 'Images',
      type: 'files',
      file: attach.attachments,
      validation: [
        { rule: 'fileSizeMax=1', error: 'Taille de fichier supérieure à 1MB, selectionner un fichier plus petit' },
        { rule: 'fileType=image', error: 'Fichier incorrect, selectionner un fichier image' }
      ]
    }
  ],
  [
    {
      name: 'options',
      label: 'Options',
      type: 'mytable',
      tableOptions: {
        paperStyle: { width: '100%', margin: '0 auto' },
        setDataParent: setProductOptions,
        defaultSorted: 'id',
        columns: [
          {
            name: 'id',
            display: false,
            enableEditing: false
          },
          {
            name: 'label',
            label: 'Nom',
            type: 'text',
            enableEditing: true,
            size: 80,
            validation: [
              {
                rule: 'req',
                error: 'Nom obligatoire'
              }
            ]
          },
          {
            name: 'type',
            label: 'Type',
            enableEditing: true,
            type: 'select',
            options: {
              type: 'data',
              returnField: 'id',
              returnFields: ['id'],
              value: 'name',
              data: [
                { id: 'text', name: 'Texte' },
                { id: 'select', name: 'Liste' },
                { id: 'color', name: 'Couleur' }
              ]
            },
            validation: [
              {
                rule: 'req',
                error: 'Type obligatoire'
              }
            ]
          },
          {
            name: 'placeholder',
            label: 'Placeholder',
            type: 'text',
            enableEditing: true,
            size: 80,
            validation: [
              {
                rule: 'req',
                error: 'Placeholder obligatoire'
              }
            ]
          },
          {
            name: 'isRequired',
            label: 'Obligatoire',
            type: 'checkbox',
            enableEditing: true
          },
          {
            name: 'maxLength',
            label: 'Longueur Max',
            enableEditing: true,
            validationWhen: (props) => props.type === 'text',
            type: 'number',
            min: 0,
            validation: [
              {
                rule: 'req',
                error: 'Longueur Max obligatoire'
              }
            ]
          },
          {
            name: 'multiplyOptionBase',
            label: 'Multiplicateur coût option',
            type: 'float',
            enableEditing: true
          },
          {
            name: 'defaultValue',
            label: 'Valeur par défaut',
            type: 'text',
            enableEditing: true,
            validationWhen: (props) => props.type !== 'text',

            size: 80,
            validation: [
              {
                rule: 'req',
                error: 'Valeur par défaut obligatoire'
              }
            ]
          },
          {
            name: 'isEditable',
            label: 'Editable',
            type: 'checkbox',
            enableEditing: true
          },
          {
            name: 'allowedAttributes',
            label: 'Attributs',
            type: 'transferList',
            options: {
              type: 'api',
              object: 'tables/globalAttribute',
              depends: 'type',
              filter: (data) => {
                console.log(data)
                return { category: 'color' }
              },
              value: 'label',
              returnField: 'id',
              returnFields: ['id']
            }
          }
        ],
        actions: {
          add: true,
          edit: true,
          delete: {
            message: 'Voulez-vous vraiment supprimer la ligne'
          }
        },
        title: 'Options',
        options: {
          pageSize: 10,
          search: false,
          paging: false,
          columnsButton: true,
          actionsColumnIndex: -1
        }
      }
    }
  ]
]
